export default [
  {
    list:[
      {
        no: '01 - 1',
        title:'전기실',
        explain:[
          {
            title:'이중 구성된 변전소',
            body: '갑작스러운 정전이나 전력 중단 사고에 대비해 주 회선과 예비 회선으로 나누어 이중으로 전력을 공급받습니다.',
          },
          {
            title:'심야전력을 이용하는 배전반',
            body: '전기부하를 줄이기 위해 심야전력을 이용하여 밤에 얼음을 얼리고, 냉수를 만들어서 한낮 시간에 서버를 식힙니다.',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-1.jpg',
      },
      {
        no: '01 - 2',
        title:'UPS 실',
        explain:[
          {
            title:'정전을 대비하는 UPS',
            body: 'UPS는 정전 시에도 전기를 공급할 수 있도록 해 줄 뿐만 아니라, IT 장비에 공급되는 전기의 주파수, 전압, 파형을 늘 일정하게 맞춰줍니다.',
          },
          {
            title:'에너지를 축적하는 Dynamic UPS',
            body: '회전형 (Dynamic) UPS는 평상시 내부의 회전체(인덕션 커플링)를 3,600rpm의 속도로 돌려 운동 에너지로 축적했다가 전원이 끊기면 곧바로 전기에너지로 변환합니다.',
            name: 'UPS(Uninterruptible Power Supply)',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-2.jpg',
      },
      {
        no: '01 - 3',
        title:'변압시설',
        explain:[
          {
            title:'특별한 전선 버스 덕트 (Bus Duct)',
            body: '높은 전압과 전류를 가진 전기를 다루는 데이터 센터에서는 ‘버스 덕트’라는 특별한 전선을 사용합니다. 버스 덕트는 전기를 안전하게 전달할 수 있도록 굵고 가볍게 하면서, 보호장치가 되어 있습니다.',
          },
          {
            title:'최소화된 변압과정 ',
            body: '데이터센터 각은  변전소로부터 인입된 전기를 IT 장비에 전달되는변압 단계를 최소화하여 전력 손실을 최소화하였습니다.',
          }
        ],
        img: '/img/dc/chuncheon/ft-1-1-3.jpg',
      },
      {
        no: '01 - 4',
        title:'STS실',
        explain:[
          {
            title:'이중 구성된 전원 공급',
            body: 'STS는 UPS 이상으로 전원이 차단됐을 때 다른 예비 회선으로 <br>자동 연결시켜 전원을 공급하는 장치로, UPS 후단에 있는 또 <br>하나의 백업 장치입니다.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-1-4.jpg',
      },
      {
        no: '01 - 5',
        title:'쿨링시스템',
        explain:[
          {
            title:'AMU ',
            body: 'AMU는 네이버만의 특별한 냉방 장치로 바깥에서 들어온 공기를 직접 이용하거나 미세한 입자의 물을 뿌려 온도를 낮춘 후 냉방에 이용합니다. 봄, 가을에는 AMU 만으로 서버실을 냉방하고,  겨울에는 바깥공기와 안의 따뜻한 공기를 섞어 온도와 습도를 조절합니다.',
            name: '*AMU (Air Misting Unit)',
          },
          {
            title:'NAMU I & II ',
            body: 'NAMU I는 찬물이 흐르는 벽에 바람을 통과시켜 기화 작용으로 온도를 낮춥니다. NAMU I을 발전시킨 NAMU II는 내부 저항을 줄이고 효율성을 높였습니다. NAMU II는 NAMU I보다 30~40% PUE 개선 효과가 있었고, 2017년 남관에 적용해 운영 효율을 검증했습니다.',
            name: '*NAMU I (NAVER Air Membrane Unit I & II)',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-2-1.jpg',
      },
      {
        no: '01 - 6',
        title: '네이버 전용 랙',
        explain: [
          {
            body: '같은 면적에 더 많은 서버를 설치하기 위해 네이버는 전용 랙을 개발했습니다. 일반 랙보다 약 40cm 높은 2.4m(51Unit)의 네이버 랙은 최대 44대의 서버를 설치할 수 있습니다.',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-3-1.jpg',
      },
      {
        no: '01 - 7',
        title: '자체 제작 고전력 랙',
        explain: [
          {
            body: '네이버 자체 제작 고전력 랙은, 6.6㎾, 30A 전력 공급이 가능한 기존 랙보다 약 두 배 용량인 랙당 11㎾, 약 50A의 전력 공급이 가능합니다.따라서 높은 전력이 필요한 서버를 더욱 안정적으로 운영할 수 있습니다.(19”/21” 호환 가능)',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-3-2.jpg',
      },
      {
        no: '01 - 8',
        title: '자동 제어 시스템',
        explain: [
          {
            body: '데이터센터 각의 ‘순차 제어’ 중심에는 빌딩 자동 제어 시스템(BAS)이 있습니다. 서버실 온도가 높아지면 자동으로 냉방 장치를 작동시킵니다. 설비 감시 시스템(FMS)은 서버실의 온도와 전류 상태를 모니터링하여 서비스 장애를 사전에 예방할 수 있습니다. 또한 BAS에서 수집된 데이터들을 건물 에너지 관리 시스템(BEMS)에서 실시간으로 분석해 관리합니다.',
            name : '빌딩 자동 제어 시스템(Building Automation System, BAS) <br/>설비 감시 시스템 (Facility Monitoring System) <br/>건물 에너지 관리 시스템(Building Energy Management)',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-4-1.jpg',
      },
      {
        no: '01 - 9',
        title: '통로 차단 시스템',
        explain: [
          {
            body: '데이터센터 각은 찬공기와 더운 공기가 섞이지 않도록 데이터센터 통로 차단 시스템(DACS)을 도입했습니다. DACS를 도입한 결과 냉복도의 온도는 2도, 열복도의 온도는 3도 가량 떨어져 냉방 효율이 높아졌습니다.',
            name: '통로 차단 시스템(Data center Aisle Containment System, DACS)',
          },
        ],
        img: '/img/dc/chuncheon/ft-1-4-2.jpg',
      }
    ]
  },
  {
    list: [
      {
        no: '02 - 1',
        title: 'OS설치 자동화',
        body: '데이터센터에서는 수많은 설비와 시스템이 24시간 가동되기 때문에 끊임없는 모니터링과 관리가 필요합니다. 그래서 데이터센터 ‘각’은 자체적으로 각종 자동화 시스템을 개발하고 도입했습니다.',
        name: 'ALIS <br/>(Automated Linux Installation System)',
        img: '/img/dc/chuncheon/ft-2-1.jpg',
        bg: '/img/dc/chuncheon/ft-2-1-p.jpg',
      },
      {
        no: '02 - 2',
        title: '원격 장애 관리 시스템',
        body: '시스템에서 발생하는 문제를 언제 어디서든 해결할 수 있도록 ADOOB를 개발했습니다. 갑자기 서버에 오류가 발생한다 해도 실시간 원격으로 시스템에 어떤 문제가 있는지를 확인하고 대응할 수 있습니다.',
        name: 'ADOOB <br/>(Auto Discovery Out of Band)',
        img: '/img/dc/chuncheon/ft-2-2.jpg',
        bg: '/img/dc/chuncheon/ft-2-2-p.jpg',
      },
      {
        no: '02 - 3',
        title: '패브릭 네트워크',
        body: '트래픽에 지연 없이 빠르게 대응하고자, 데이터센터 내부 네트워크 구조에 ‘패브릭’을 도입했습니다. 패브릭은 마치 척추처럼 데이터센터 내 전체 서버, 인터넷, 부하 분산 장치(load balancer)를 연결하는 분산 백본(backbone)을 말합니다.',
        img: '/img/dc/chuncheon/ft-2-3.jpg',
        bg: '/img/dc/chuncheon/ft-2-3-p.jpg',
      },
      {
        no: '02 - 4',
        title: 'AMIGO, Bong9 시스템',
        body: '인터넷상의 공격이나 온·오프라인 인프라 오류로 인한 장애에 빠르게 대응하기 위해, AMIGO라는 자체 보안시스템에서 악성코드가 숨어있는 사이트를 탐지하고, Bong9는 악성코드 유포 URL을 사전 차단, 분석 후 차단, 모니터링합니다.',
        img: '/img/dc/chuncheon/ft-2-4.jpg',
        bg: '/img/dc/chuncheon/ft-2-4-p.jpg',
      },
      {
        no: '02 - 5',
        title: '표준화된 실시간 장애 관리',
        body: '자체적으로 개발한 TTS 도구를 사용하여 언제 어디서나 서비스 장애에 빠르게 대응할 수 있습니다. 고객에게 미치는 영향을 고려해 다섯 단계의 장애 정도에 따라 효율적으로 처리합니다.',
        name: 'TTS <br/>(Trouble Ticket System)',
        img: '/img/dc/chuncheon/ft-2-5.jpg',
        bg: '/img/dc/chuncheon/ft-2-5-p.jpg',
      },
    ]
  },
  {
    list: [
      {
        no: '03 - 1',
        title: '보안 공격 <br/>탐지 및 차단',
        body: 'DDoS (Distributed Denial of Service)공격은 웹 서비스가 중심인 IT 기업에 가장 큰 위협입니다. 네이버도 24시간 모니터링을 통해 DDoS 공격 징후가 보이면 즉시 전담반을 구성합니다. 보다 근본적인 대응을 위해 수집한 공격 정보를 바탕으로 효율적인 대응 시스템을 만들고, 꾸준히 데이터를 수집하여 시스템을 개선해가고 있습니다.',
        img: '/img/dc/chuncheon/ft-3-1.svg',
        imgM: '/img/dc/chuncheon/ft-3-1-m.svg',
      },
      {
        no: '03 - 2',
        title: '데이터 유실을 막는 <br/>이중화 설계',
        body: '서버에 오류가 발생했을 때를 대비해 네트워크상에 예비 서버를 만들어 두는 것을 ‘데이터(서비스) 이중화’라고 합니다. 네이버 블로그에 글을 저장하면 다음 날 이 글은 네이버 데이터센터 내 여러 곳에 저장됩니다. 이중화 된 서버들은 만약을 대비해 다른 데이터센터에도 실시간으로 데이터를 저장해 서비스 중단을 막습니다.',
        img: '/img/dc/chuncheon/ft-3-2.svg',
        imgM: '/img/dc/chuncheon/ft-3-2-m.svg',
      },
    ]
  }
];
